export type CXMFlagNames =
  | "nx.cxm.test"
  | "nx.cxm.show-vin-employee-management"
  | "nx.cxm.show-user-management"
  | "nx.cxm.edit-dealer-settings"
  | "nx.cxm.show-trending-duplicates-tab"
  | "nx.cxm.kill.crw-deallist-persona"
  | "nx.cxm.show-dealtrack"
  | "nx.cxm.show-dealcomments"
  // eslint-disable-next-line @cspell/spellchecker
  | "nx.cxm.show-addadeal-button"
  | "nx.cxm.show-data-purge-message"
  | "nx.cxm.show-quill-editor"
  | "cxm.use-new-create-deal-target.enable"
  | "nx.cxm.show-stationery"
  | "nx.cxm.show-emoji-email"
  | "nx.cxm.show-emoji-text"
  | "nx.cxm.inbox-show-plus-button"
  | "cxm.cdl.analytics.enable"
  | "nx.cxm.use-message-details-v2"
  | "nx.cxm.dealer-phone-status-checks"
  | "nx.cxm.inbox-show-media-library"
  | "nx.cxm.inbox.use-single-endlink";

export type TestFlagNames = "devTestFlag";

type AllFlagsNames = TestFlagNames | CXMFlagNames;

type AppNames = "test" | "cxm" | "customer-inbox";

type Flags = Array<{ name: AllFlagsNames; apps: Array<AppNames> }>;

const FLAGS: Flags = [
  /** Mock flag only for test page */
  {
    name: "devTestFlag",
    apps: ["test"]
  },
  {
    /** nx.cxm.test
     * Intergration test toggle for validating LD inside CXM */
    name: "nx.cxm.test",
    apps: ["cxm"]
  },
  {
    /** nx.cxm.show-vin-employee-management
     * Show list employees list button  */
    name: "nx.cxm.show-vin-employee-management",
    apps: ["cxm"]
  },
  {
    /** nx.cxm.show-user-management
     * Show User management */
    name: "nx.cxm.show-user-management",
    apps: ["cxm"]
  },
  {
    /** nx.cxm.edit-dealer-settings
     * Show dealer management visible data columns */
    name: "nx.cxm.edit-dealer-settings",
    apps: ["cxm"]
  },
  {
    /** nx.cxm.kill.crw-deallist-persona
     * hide crw deal list persona */
    name: "nx.cxm.kill.crw-deallist-persona",
    apps: ["cxm"]
  },
  {
    /** nx.cxm.show-dealtrack
     * Show deal track */
    name: "nx.cxm.show-dealtrack",
    apps: ["cxm"]
  },
  {
    /** nx.cxm.show-dealcomments
     * Show deal comments */
    name: "nx.cxm.show-dealcomments",
    apps: ["cxm"]
  },
  {
    // eslint-disable-next-line @cspell/spellchecker
    /** nx.cxm.show-addadeal-button
     * Show create new deal button */
    // eslint-disable-next-line @cspell/spellchecker
    name: "nx.cxm.show-addadeal-button",
    apps: ["cxm"]
  },
  {
    /** nx.cxm.show-trending-duplicates-tab
     * show trending duplicate tab */
    name: "nx.cxm.show-trending-duplicates-tab",
    apps: ["cxm"]
  },
  {
    /** nx.cxm.show-data-purge-message
     * Show data purge message */
    name: "nx.cxm.show-data-purge-message",
    apps: ["cxm"]
  },
  {
    name: "nx.cxm.show-quill-editor",
    apps: ["cxm"]
  },
  {
    name: "cxm.use-new-create-deal-target.enable",
    apps: ["cxm"]
  },
  {
    name: "nx.cxm.show-stationery",
    apps: ["cxm"]
  },
  {
    name: "nx.cxm.show-emoji-email",
    apps: ["cxm"]
  },
  {
    name: "nx.cxm.show-emoji-text",
    apps: ["cxm"]
  },
  {
    name: "nx.cxm.inbox-show-plus-button",
    apps: ["cxm"]
  },
  {
    name: "cxm.cdl.analytics.enable",
    apps: ["cxm"]
  },
  {
    /** nx.cxm.use-message-details-v2
     * Use v2 endpoint for message details API */
    name: "nx.cxm.use-message-details-v2",
    apps: ["cxm"]
  },
  {
    /** nx.cxm.dealer-phone-status-checks
     * Enable dealer phone campaign/readiness validation for texting */
    name: "nx.cxm.dealer-phone-status-checks",
    apps: ["cxm"]
  },
  {
    /** nx.cxm.inbox-show-media-library
     * Show Video option in plus button menu — gates media-library-remote load */
    name: "nx.cxm.inbox-show-media-library",
    apps: ["cxm"]
  },
  {
    /** nx.cxm.inbox.use-single-endlink
     * When ON, uses postMediaEndlink (single endlink for all media in one widget).
     * When OFF (default), uses postMultipleMediaEndlinks (one endlink per media item). */
    name: "nx.cxm.inbox.use-single-endlink",
    apps: ["cxm"]
  }
];

export const getActiveFlags = (appName: AppNames) => {
  return FLAGS.reduce((acc, { name, apps }, i) => {
    if (apps.some(app => app === appName)) {
      return {
        ...acc,
        [name]: true
      };
    } else {
      return acc;
    }
  }, {});
};
